import React from 'react';

interface Iprops {
  iconLink?: string
}

function Adress(props: Iprops) {
  const {
    iconLink,
  } = props
  return (
    <div className=' h-[160px] pt-[24px]'>
      <div className=' h-[24px] text-lg text-center text-black font-sans'><a className=' not-italic text-blue hover:underline' href={`/privacy?iconLink=${iconLink}`}>Privacy and cookies policy</a></div>
      <div className=' mt-[12px] text-ms text-center text-grey font-sans'>©2013-2022. Month2Month</div>
      {/* <div className='text-ms text-center text-grey font-sans'>DBA Month2Month</div> */}
    </div>
  );
}

export default Adress;
